import { render, staticRenderFns } from "./MovementsChangePopup.vue?vue&type=template&id=05d7cc65&scoped=true"
import script from "./MovementsChangePopup.vue?vue&type=script&lang=ts"
export * from "./MovementsChangePopup.vue?vue&type=script&lang=ts"
import style0 from "./MovementsChangePopup.vue?vue&type=style&index=0&id=05d7cc65&prod&lang=scss&scoped=true"
import style1 from "./MovementsChangePopup.vue?vue&type=style&index=1&id=05d7cc65&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7cc65",
  null
  
)

export default component.exports